// extracted by mini-css-extract-plugin
export default {"container":"spacing-module__container--3_7e2"};